import { render, staticRenderFns } from "./contract-detail-ecommerce.vue?vue&type=template&id=6fa61ce8&scoped=true"
import script from "./contract-detail-ecommerce.vue?vue&type=script&lang=js"
export * from "./contract-detail-ecommerce.vue?vue&type=script&lang=js"
import style0 from "./contract-detail-ecommerce.vue?vue&type=style&index=0&id=6fa61ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa61ce8",
  null
  
)

export default component.exports